/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_9_HInputs */

const en_privacy_9_h = /** @type {(inputs: Privacy_9_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes`)
};

const id_privacy_9_h = /** @type {(inputs: Privacy_9_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan`)
};

/**
* | output |
* | --- |
* | "Changes" |
*
* @param {Privacy_9_HInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const privacy_9_h = /** @type {((inputs?: Privacy_9_HInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_9_HInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_9_h(inputs)
	return en_privacy_9_h(inputs)
});